import { render } from "./healthAssessment.vue?vue&type=template&id=6e830f5e&scoped=true"
import script from "./healthAssessment.vue?vue&type=script&lang=js"
export * from "./healthAssessment.vue?vue&type=script&lang=js"

import "./healthAssessment.vue?vue&type=style&index=0&id=6e830f5e&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e830f5e"]])

export default __exports__